import React, { Component, createRef, FC, FunctionComponent, useContext, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { connect, useDispatch, useSelector } from 'react-redux'
import CryptoJS from 'crypto-js'
import LocationApplicationType from '../../../types/LocationApplicationType'
import Provider from '../../../types/Provider'
import ActionData from '../../../types/ActionData'
import RootState from '../../../types/RootState'
import User from '../../../types/User'
import moment from 'moment'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import AuthorizationDetailModal from '../../../components/Modals/AuthorizationDetailModal'
import DatePicker from 'react-datepicker'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import paginationFactory, { PaginationProvider, PaginationTotalStandalone, PaginationListStandalone } from 'react-bootstrap-table2-paginator'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Accordion, Button, Card, Col, Form, Nav, Row, Tab } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { formatDate, formatPhoneNumber, convert } from '../../../utils/dataTools'
import { getLocationApplications, addLocationApplication, resetLocationApplication } from '../../../redux/actions/locationApplication'
import { addUserActivity } from '../../../redux/actions/authentication'
import { CSVLink } from 'react-csv'
import './index.css'
import { truncate, formatNoUTCDate, formatUTCDate, formatCompleteDate } from '../../../utils/stringTools'
import Organization from '../../../types/Organization'
import { startCase } from 'lodash'
import Status from '../../../components/Status'
import LocationApplicationTruncated from '../../../types/LocationApplicationTruncated'
import { AbilityContext } from '../../../config/Can'
import { AppAbility } from '../../../config/ability'
import { render } from 'react-dom'
import ApplyNewLocationModal from '../../../components/Modals/ApplyNewLocationModal'
import { getDomainName } from '../../../utils/envVariables'
import request from 'superagent'

const renderActionButton = (row: any, onCloseLocationApplication: (row: any, type: string) => void, history: any) => {
  const startingApplicationTab = row.applicationType === 'residential' && row['12BedCertification'] ? 'certification' : 'application'

  return <Button
    className='action-btn'
    variant='info'
    onClick={() => history.push(`/provider/locationApplication/${startingApplicationTab}/${row.locationApplicationId}`)}
    style={{ marginBottom: 10, marginRight: 10 }}
  >
    View
  </Button>
}

const formatAddress = (cellContent: any, row: any) => {
  if (!row.address || !Array.isArray(row.address)) return 'Not provided';

  const physicalAddress = row.address.find(addr => addr.addressType === 'Physical');
  if (!physicalAddress) return 'Not provided';

  const addressParts = [];

  if (physicalAddress.address1) addressParts.push(physicalAddress.address1);
  if (physicalAddress.address2) addressParts.push(physicalAddress.address2);
  if (physicalAddress.city) addressParts.push(physicalAddress.city);
  if (physicalAddress.state) addressParts.push(physicalAddress.state);
  if (physicalAddress.zipCode) addressParts.push(physicalAddress.zipCode);

  return addressParts.length > 0 ? addressParts.join(', ') : 'Not provided';
}

interface Props {
  height: number;
  applications: Array<LocationApplicationTruncated>;
  applicationsData: ActionData;
  activeKey: string;
  tabName: string;
  user: User;
  selectedOrganization: Organization;
  addUserActivity: (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number; authorizationId?: number }, token: string) => void;
  getLocationApplications: (id: number, token: string) => void;
  onCloseLocationApplication?: (row: any, type: string) => void;
  onViewClosureDenialInformation?: (row: any, type: string) => void;
  // onSelectLocationApplication: (agencyName: string) => void;
}

interface State {
  key: string;
  openApplyNewLocation: boolean;
  addingLocationApplication: boolean;
  // createdApplication?: LocationApplicationType;
  selectedLocationApplication?: LocationApplicationType;
}


// const CarePlan: FunctionComponent<Props> = ({ height }: Props) => {

const LocationApplicationTable: FunctionComponent<Props> = ({ height, tabName, user, selectedOrganization, onCloseLocationApplication, onViewClosureDenialInformation, getLocationApplications }: Props) => {
  const [state, setState] = React.useState<State>({
    key: 'application-list',
    openApplyNewLocation: false,
    addingLocationApplication: false,
    selectedLocationApplication: null,
  });
  const history = useHistory();
  const location = useLocation();
  const applications = useSelector((state: RootState) => state.locationApplication.locationApplications.data);
  const addLocationAppState = useSelector((state: RootState) => state.locationApplication.addLocationApplication);
  const [activeSubTab, setActiveSubTab] = React.useState('active');
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const subTab = params.get('subTab');
    if (subTab) {
      setActiveSubTab(subTab);
    }
  }, [location]);

  useEffect(() => {
    if (addLocationAppState.error) {
      console.error("Error creating location application:", addLocationAppState.error);
      setState((prevState) => ({
        ...prevState,
        agreementError: true,
        addingLocationApplication: false
      }));
    }
    else if (addLocationAppState.success && addLocationAppState.data) {
      const createdApplication = addLocationAppState.data;
      const certificationNeeded = createdApplication['12BedCertification'];
      const applicationTab = certificationNeeded ? 'certification' : 'application';

      setState((prevState) => ({
        ...prevState,
        openApplyNewLocation: false,
        addingLocationApplication: false,
        createdApplication
      }));
      history.push(`/provider/locationApplication/${applicationTab}/${createdApplication.locationApplicationId}`);

      // clear addLocationApplication state after navigation
      dispatch(resetLocationApplication());
    }
  }, [addLocationAppState]);

  const handleSubTabChange = (subTab: string) => {
    setActiveSubTab(subTab);
  };

  const filteredApplications = React.useMemo(() => {
    if (!applications) return [];

    switch (activeSubTab) {
      case 'active':
        return applications.filter(app => app.status === 'STARTED' || app.status === 'SUBMITTED' || app.status === 'REJECTED');
      case 'approved':
        return applications.filter(app => app.status === 'APPROVED');
      case 'closed':
        return applications.filter(app => app.status === 'CLOSED' || app.status === 'DENIED');
      default:
        return applications;
    }
  }, [applications, activeSubTab]);

  const defaultColumns = [{
    dataField: 'agencyName',
    text: 'Location Name',
    sort: true,
    formatter: (cellContent, row) => row.legalEntity || cellContent,
  }, {
    dataField: 'address',
    text: 'Physical Address',
    sort: false,
    formatter: formatAddress,
    headerStyle: () => {
      return { width: '20%' }
    },
    style: () => {
      return { width: '20%' }
    }
  }, {
    dataField: 'applicationType',
    text: 'Type',
    sort: true,
    formatter: (cellContent) => startCase(cellContent),
    headerStyle: () => {
      return { width: '10%' }
    },
    style: () => {
      return { width: '10%' }
    }
  }, {
    dataField: '12BedCertification',
    text: 'Certified',
    sort: true,
    formatter: (cellContent) => cellContent ? 'Yes' : 'No',
    headerStyle: () => {
      return { width: '10%' }
    },
    style: () => {
      return { width: '10%' }
    }
  }, {
    dataField: 'status',
    text: 'Status',
    sort: true,
    formatter: (cellContent, row) => <Status cellContent={cellContent} row={row} />
  }, {
    dataField: 'submitDate',
    text: 'Date Submitted',
    sort: true,
    formatter: (cellContent) => cellContent ? formatCompleteDate(cellContent) : '',
    headerStyle: () => {
      return { width: '10%' }
    },
    style: () => {
      return { width: '10%' }
    }
  },
  {
    dataField: 'action',
    text: 'Action',
    sort: false,
    formatter: (cellContent, row) => renderActionButton(row, onCloseLocationApplication, history)
  }]

  // const columns = [{
  //   dataField: 'submitDate',
  //   text: 'Date Submitted',
  //   sort: true,
  //   formatter: (cellContent) => cellContent ? formatCompleteDate(cellContent) : '',
  //   headerStyle: () => {
  //     return { width: '10%' }
  //   },
  //   style: () => {
  //     return { width: '10%' }
  //   }
  // },
  // ...defaultColumns]

  const closedColumns = [{
    dataField: 'denialClosedDate',
    text: 'Date Denied / Closed',
    sort: true,
    formatter: (cellContent) => cellContent ? formatCompleteDate(cellContent) : '',
    headerStyle: () => {
      return { width: '10%' }
    },
    style: () => {
      return { width: '10%' }
    }
  },
  ...defaultColumns]


  const handleSubmitApplicationType = async (values: any) => {
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''

    setState((prevState) => ({
      ...prevState,
      addingLocationApplication: true
    }))

    if (!token) {
      console.error("Token not found");
      setState((prevState) => ({
        ...prevState,
        agreementError: true,
        addingLocationApplication: false
      }));
      return;
    }

    try {
      dispatch(addLocationApplication(values, selectedOrganization.organization_id, user.user_id, token));
    } catch (error) {
      console.error("Error dispatching action:", error);
      setState((prevState) => ({
        ...prevState,
        agreementError: true,
        addingLocationApplication: false
      }));
    }
  };

  const handleOpenModal = () => {
    setState((prevState) => ({ ...prevState, openApplyNewLocation: true })); // Open modal
  }

  const handleCloseModal = () => {
    setState((prevState) => ({ ...prevState, openApplyNewLocation: false })); // Close modal
  }
  return (
    <div className="applications-container">
      <div className="applications-filter-and-sort">
        <div className="applications-nav-container">
          <Nav variant="pills" className="applications-nav">
            <Nav.Item>
              <Nav.Link
                active={activeSubTab === 'active'}
                onClick={() => handleSubTabChange('active')}
              >
                Active
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                active={activeSubTab === 'approved'}
                onClick={() => handleSubTabChange('approved')}
              >
                Approved
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                active={activeSubTab === 'closed'}
                onClick={() => handleSubTabChange('closed')}
              >
                Closed/Denied
              </Nav.Link>
            </Nav.Item>
          </Nav>
          {!user.isLakeland ?
            <Button
              className="btn apply-location-btn"
              onClick={handleOpenModal}
            >
              <FontAwesomeIcon icon={['fas', 'plus-circle']} /> Apply for New Location
            </Button>
            : null}
        </div>
      </div>

      <div className="applications-table">
        <BootstrapTable
          keyField="locationApplicationId"
          data={filteredApplications}
          columns={activeSubTab === 'closed' ? closedColumns : defaultColumns}
          bordered={false}
          classes="table-hover"
          noDataIndication="No applications found"
        />
      </div>

      <ApplyNewLocationModal
        show={state.openApplyNewLocation}
        onClose={handleCloseModal}
        onSubmit={handleSubmitApplicationType}
        addingLocationApplication={state.addingLocationApplication}
        addLocationApplication={{
          loading: false,
          data: null,
          error: null,
          success: false
        }}
      />
    </div>
  );
}


const mapStateToProps = (state: RootState) => ({
  applications: state.locationApplication.locationApplications || [],
  applicationsData: state.locationApplication.locationApplications.data || [],
  user: state.authentication.user.data,
})

const mapDispatchToProps = {
  addUserActivity,
  getLocationApplications
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationApplicationTable)